import React from 'react';

const StatCard = ({ title, value, icon, subtitle }) => (
    <div className="p-6 bg-white rounded-lg shadow">
        <div className="flex items-center">
            <div className="p-3 bg-indigo-100 rounded-full">{icon}</div>
            <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">{title}</p>
                <p className="text-2xl font-bold">{value}</p>
                {subtitle && <p className="text-xs text-gray-500 mt-1">{subtitle}</p>}
            </div>
        </div>
    </div>
);

export default StatCard;